import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const ContentCard = ({ title, content }) => {
  return (
    <Card sx={{ minWidth: 275, padding: 0, margin: 0, boxShadow: 'none' }}>
      <CardContent 
          sx={{ 
              padding: '0px 0px 16px 0px',
              '@media (min-width:768px)': {
                  marginLeft: '40px',
              }
          }}
      >
        <Typography align="left" variant="h6" gutterBottom sx={{ fontFamily: 'Manrope, sans-serif' }}>
          {title}
        </Typography>
        <Typography component="div" align="left" sx={{ fontFamily: 'Manrope, sans-serif' }}>
          {content}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ContentCard;
